import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import pluralizer from 'pluralize'

import Button from 'discada/dist/Button'

import {
  getFilterGroupLabel,
  getSelectedFilterValue,
} from 'selectors/inventorySelectors'

import { addAndStoreFilter } from 'actions/inventoryActions'


import './InventoryStory.scss'

const LABELS = {
  //condition: 'Show me',
  //make: 'from',
  //year: 'from',
  //feature: 'with',
}

const OVERRIDE_LABEL = {
  condition: 'New and Used',
}

export function StoryFilter(props) {
  let { selectedValue, label, group, isOk, addAndStoreFilter } = props

  if (!isOk) return null

  if (selectedValue) {
    selectedValue = (Array.isArray(selectedValue)
      ? selectedValue
      : [selectedValue]
    )
      .filter(v => v && typeof v === 'string')
      .map(v => v.split('-').join(' '))
      .join(', ')
  }

  return (
    <Button
      size={props.size}
      icon={selectedValue ? 'search' : 'plus'}
      className={c('filter-button', 'story-filter', `story-fitler-${group}`, {
        'story-filter-has-value': !!selectedValue,
        'story-filter-large': props.size === 'large',
      })}
      onClick={() =>
        addAndStoreFilter({
          showInventoryFilters: true,
          filterGroup: group,
        })
      }
    >
      {selectedValue ? (
        <>
          {LABELS[group] && (
            <span className="filter-label">{LABELS[group]}</span>
          )}
          <span className="filter-value-value">{selectedValue}</span>
        </>
      ) : (
        <>
          {LABELS[group] && (
            <span className="filter-label">{LABELS[group]}</span>
          )}
          {OVERRIDE_LABEL[group] || `All ${pluralizer(label || group)}`}
        </>
      )}
    </Button>
  )
}

function mapStateToProps(state, op) {
  let selectedValue = getSelectedFilterValue(state, op.group)

  return {
    ...op,
    label: getFilterGroupLabel(state, op.group) || '',
    selectedValue,
    isOk:
      selectedValue ||
      (!op.prereq && !op.hideWhen) ||
      (op.prereq && op.prereq.some(p => getSelectedFilterValue(state, p))) ||
      (op.hideWhen && !op.hideWhen.some(p => getSelectedFilterValue(state, p))),
  }
}

export default connect(
  mapStateToProps,
  { addAndStoreFilter },
)(StoryFilter)
